import PropTypes from 'prop-types';

export const userTypePropTypes = {
	excludeTypes: PropTypes.arrayOf(PropTypes.string),
	onChange: PropTypes.func,
	onValidate: PropTypes.func,
	validate: PropTypes.bool,
};
